import AjaxInvitationService from './ajax-invitation-service'

class VehicleMakeService extends AjaxInvitationService {

  getList(code) {
    let headers = this.getInvitationHeader(code)
    return this.makeGetRequest('/by-invitation/makes', null, headers)
  }

  getExisting(code, license) {
    let headers = this.getInvitationHeader(code)
    return this.makeGetRequest(`/by-invitation/existing/${license}`, null, headers)
  }
}

const _instance = new VehicleMakeService()
export default _instance